import { render, staticRenderFns } from "./promoterDrawer.vue?vue&type=template&id=530a899c&scoped=true"
import script from "./promoterDrawer.vue?vue&type=script&lang=js"
export * from "./promoterDrawer.vue?vue&type=script&lang=js"
import style0 from "./promoterDrawer.vue?vue&type=style&index=0&id=530a899c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_fa4cvkteopfvx2274rwhhr2idm/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a899c",
  null
  
)

export default component.exports